import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";

export default function GamingBettingLicenseSaintLucia (){

    return (
        <main className='main'>

            <IntroSection
                title="Gaming & Betting License – Saint Lucia"
                subtitle="Operate Lotteries, Betting, and Limited Online Gaming in the Caribbean"
                description =
                    "
                        <b>Saint Lucia</b> provides a <b>regulated framework</b> for <b>lotteries, betting, and certain gaming operations</b>. Though not as internationally recognized as <b>Curacao</b> or <b>Malta</b>, <b>Saint Lucia’s gaming licenses</b> are <b>legitimate</b>, <b>government-backed</b>, and <b>regionally respected</b>.
                    <br/>
                        The licenses are overseen by the <b>FSRA (Financial Services Regulatory Authority)</b> and <b>related gaming authorities</b>.
                    "
                badges={
                    [
                        "Lotteries",
                        "Sports Betting",
                        "Online Gaming (limited recognition)"
                    ]
                }
                buttonText="Request a Saint Lucia Gaming Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/gaming-betting-license–saint-lucia-hero.png")}
                imageAlt="Gaming License Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Saint Lucia for Gaming?'
                        blocks={[
                            {
                                items:
                                    [
                                        { title: "Regional Recognition", text: "licensed and supervised, not a grey market" },
                                        { title: "Government Oversight", text: "FSRA and national regulators ensure legitimacy" },
                                        { title: "Flexible Options", text: "betting shops, lotteries, and limited online gaming" },
                                        { title: "Tax Neutrality", text: "territorial tax regime (foreign earnings exempt)" },
                                        { title: "Entry-Level Jurisdiction", text: "lower costs than EU gaming hubs" }
                                    ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Types of Gaming Licenses in Saint Lucia"
                        blocks={[
                            {
                                title: "Lottery License",
                                items:
                                    [
                                        { text: "National and private lotteries" },
                                        { text: "Can be combined with charity and fundraising gaming" }
                                    ]
                            },
                            {
                                title: "Sports Betting License",
                                items:
                                    [
                                        { text: "Betting shops and retail sportsbooks" },
                                        { text: "Can include online sports betting platforms with approval" },
                                        { text: "Regional strength, particularly in the Caribbean" }
                                    ]
                            },
                            {
                                title: "Online Gaming License (Limited)",
                                items:
                                    [
                                        { text: "Covers online betting platforms, poker, and casino games" },
                                        { text: "Recognition is regional, not as strong as Curacao, Malta, or Isle of Man" },
                                        { text: "Suitable for operators focusing on LatAm/Caribbean players" }
                                    ]
                            },
                        ]}
                    />


                    <FeatureCards
                        title='Capital & Requirements'
                        features={
                            [
                                { title: "Sports Betting", text: "~USD 100,000 minimum" },
                                { title: "Lottery & Online", text: "~USD 150,000–200,000" },
                                { title: "Local Incorporation", text: "St Lucia entity required" },
                                { title: "AML/KYC Compliance", text: "aligned with FATF standards" },
                                { title: "Annual Reporting", text: "audits and FSRA filings" }
                            ]
                        }
                    />

                    <LocationTimeline
                        title='Benefits of a Saint Lucia Gaming License'
                        item={
                            [
                                { title: "Legitimate & Licensed", text: "official regulator oversight" },
                                { title: "Covers Land & Online", text: "betting shops + digital expansion" },
                                { title: "Banking Access", text: "stronger than unlicensed offshore models" },
                                { title: "Lower Barriers", text: "more affordable than EU licenses" },
                                { title: "LatAm Gateway", text: "useful for Caribbean-facing operations" }
                            ]
                        }
                    />

                    {/* Services */}
                    <ServiceCards
                        title='Licensing Process'
                        services={
                            [
                                { title: "Consultation & Planning", text: "define lottery, betting, or online scope" },
                                { title: "Entity Incorporation", text: "set up a Saint Lucia company" },
                                { title: "Application Submission", text: "business plan, compliance manuals, financial proof" },
                                { title: "FSRA / Gaming Authority Review", text: "due diligence on directors & shareholders" },
                                { title: "Approval & Licensing", text: "typically 6–9 months" }
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: " 6-9 months",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Setup Costs",
                                description: "from USD 80,000+ (legal, compliance, advisory)",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Capital Requirement",
                                description: "USD 100k–200k",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Annual Costs",
                                description: "regulator fees, audits, compliance",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Specialists in Caribbean gaming licenses" },
                                { text: "End-to-end support: incorporation, license filing, compliance manuals" },
                                { text: "Partnerships with gaming software providers, PSPs, and hosting firms" },
                                { text: "Balanced guidance: St Lucia vs Curacao vs Panama vs Western Sahara" },
                                { text: "Ongoing compliance support with FSRA" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title=
                            "
                                Looking to launch a lottery, sportsbook, or online betting platform in the Caribbean?                            "
                         description=
                             "
                                <b>Saint Lucia</b> offers <b>gaming licenses</b> under <b>FSRA</b>, combining <b>regional credibility</b> and <b>tax advantages</b>.
                             "
                         buttonText='Book a Saint Lucia Gaming Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is Saint Lucia gaming license globally recognized?",
        content: [
            { type: "answer", text: "Not as strong as Curacao or Malta — mainly recognized regionally." },
        ],
    },
    {
        question: "What’s the capital requirement?",
        content: [
            { type: "answer", text: "USD 100k–200k depending on activity." },
        ],
    },
    {
        question: "Can I operate an online casino under St Lucia license?",
        content: [
            { type: "answer", text: "Yes, but recognition is mainly Caribbean/LatAm-focused." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Usually 6–9 months." },
        ],
    },
    {
        question: "Why choose St Lucia over Curacao?",
        content: [
            { type: "answer", text: "Lower entry barriers and regional legitimacy, but not as strong internationally." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "We licensed a sportsbook in Saint Lucia. Offshore Advisory made the FSRA process efficient and banking-friendly.",
            author: "Martin K.",
            role: "Sports Betting Operator"
        },
        {
            quote: "Saint Lucia was ideal for our Caribbean lottery project. Offshore Advisory managed the licensing end-to-end.",
            author: "Alicia G.",
            role: "Lottery Investor"
        }
    ]
;